import { graphql } from 'relay-runtime';

export const attemptsWithoutPassing = graphql`
  query AttemptsWithoutPassingQuery($filter: StudentSkillAssessmentWeeklySnapshotFilterInput!) {
    studentsAttemptedSkillsWithoutPassing(filter: $filter) {
      student {
        id
        firstName
        lastName
        publicUserId
      }
      attempts
    }
  }
`;
